import React from 'react';
import Error, { PATH } from 'src/pages/error';
import { IRouter } from 'src/interfaces/route';

const routes: IRouter[] = [
  {
    children: [
      {
        index: true,
        path: PATH.NOT_FOUND,
        element: <Error.NotFound />,
      },
    ],
  },
  {
    children: [
      {
        index: true,
        path: PATH.INTERNAL_SERVER,
        element: <Error.InternalServer />,
      },
    ],
  },
  {
    children: [
      {
        index: true,
        path: PATH.FORBIDDEN,
        element: <Error.Forbidden />,
      },
    ],
  },
  {
    children: [
      {
        index: true,
        path: '*',
        element: <Error.NotFound />,
      },
    ],
  },
];

export default routes;
